import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/reset.scss'
import '@/styles/index.scss'
// import vdr from 'vue-draggable-resizable-gorkys'
import vdr from 'vue-draggable-resizable-kylin'
import store from './store'

// 导入默认样式
import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css'

import ElementUI from 'element-ui'

// 全局方法
import './plugins'
// 全局组件
import 'src/components'

import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'echarts-extension-amap'

import { trimStrings } from '@/utils/common'

Vue.prototype.trimStrings = trimStrings

Vue.component('vue-draggable-resizable', vdr)
Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
